module.exports = __webpack_public_path__ + "static/img/card-card-3.8ae154f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-card-3.jpg
// module id = 5aOw
// module chunks = 1